
<div class="switch-btn-area">
    <div class="switch-btn-area-label">{{label}}</div>
    <div class="switch-btn-area-value">
      <dx-switch [value]="data===1?true:false"
      (onValueChanged)="valueChange($event)"
      [readOnly]="readOnly"
      [width]="'50px'"
      class="custom-switch"></dx-switch>
    </div>
  </div>